var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"cool-ui-loading",style:({ backgroundColor: _vm.bgColor })},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"icon",attrs:{"src":"https://coolcdn.igetcool.com/p/2023/12/4b78239cb77a319b22faadc4a5ef7f27.gif","alt":""}}),_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }